const { appendFilter } = require('../../../queries');
const addAutopayScheduledTransactionsQueries = require('../../../queries/configs/AutopayScheduledTransactions');

module.exports = addAutopayScheduledTransactionsQueries(function ({ scheduledTransactionId }) {
  return ({
    queriesFilter: appendFilter('scheduledTransactionId', scheduledTransactionId),
  })
});
